import { lazy } from "react";

export { JOB_OFFER_PATH } from "./path";
export const JobOfferPage = lazy(() => import("./page"));
